/* @flow */
import { mapValues } from 'lodash/fp';
import * as React from 'react';

import { withMediaType } from '@sonyged/ext-proc';

import { injectScale } from './ScaleContext';

type BubbleProps = {
  scale: number,
  mediaType: 'mobile' | 'smallPC' | 'largePC',
  children: React.Node,
};

const StoreTalkBubble = withMediaType(
  injectScale(({ children, scale, mediaType }: BubbleProps) => {
    let designSizes = {
      top: 50,
      width: 320,
      height: 70,
      fontSize: 18,
      borderRadius: 5,
      paddingY: 10,
      paddingX: 12,
    };

    if (mediaType === 'largePC') {
      designSizes = {
        top: 90,
        width: 600,
        height: 90,
        fontSize: 24,
        borderRadius: 8,
        paddingY: 12,
        paddingX: 24,
      };

      const pcScale = 474 / 810;
      designSizes = mapValues(x => x * pcScale, designSizes);
    }

    const sizes = mapValues(x => x * scale, designSizes);

    const style = {
      top: sizes.top,
      width: sizes.width,
      height: sizes.height,
      fontSize: sizes.fontSize,
      borderRadius: sizes.borderRadius,
      padding: `${sizes.paddingY}px ${sizes.paddingX}px`,
    };

    return (
      <div style={style} className="proc-storeTalkBubble">
        {children}
      </div>
    );
  })
);
StoreTalkBubble.displayName = 'StoreTalkBubble';

const StoreTalkBubbleArrow = injectScale(({ scale }: { scale: number }) => {
  const style = {
    borderLeftWidth: 6 * scale,
    borderRightWidth: 6 * scale,
    borderTopWidth: 8 * scale,
  };

  return <div className="proc-storeTalkBubble-arrow" style={style} />;
});
StoreTalkBubbleArrow.displayName = 'StoreTalkBubbleArrow';

export { StoreTalkBubble, StoreTalkBubbleArrow };
